<div fxLayout="column" fxFlexFill>
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" [multiTemplateDataRows]="true" class="regular-table responsive"
               matSort matSortActive="username" matSortDirection="desc" matSortDisableClear>
      <ng-container matColumnDef="username">
        <mat-header-cell *matHeaderCellDef mat-sort-header="username">Username</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Username:</span>
          <span>
            <a [routerLink]="[detailsUrl, row.id]">
              {{ row.username }}
            </a>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="firstName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="firstName">First Name</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">First Name:</span>
          <span>{{ row.firstName }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="lastName">Last Name</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Last Name:</span>
          {{ row.lastName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="extension">
        <mat-header-cell *matHeaderCellDef mat-sort-header="extension">Extension</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Extension:</span>
          {{ row.extension }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="roleName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="roleName">Role</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Role:</span>
          {{ row.roleName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="approved">
        <mat-header-cell *matHeaderCellDef mat-sort-header="approved">Enabled</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Enabled:</span>
          <div>{{ row.approved | yesno}}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="enableCounterPath">
        <mat-header-cell *matHeaderCellDef mat-sort-header="enableCounterPath">SoftPhone Active</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">SoftPhone Active:</span>
          <div>{{ row.enableCounterPath | yesno}}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="ccsUserName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="ccsUserName">SoftPhone Username</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">SoftPhone Username:</span>
          <div>{{ row.ccsUserName}}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="counterPathPassword">
        <mat-header-cell *matHeaderCellDef mat-sort-header="counterPathPassword">SoftPhone Password</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">SoftPhone Password:</span>
          <app-show-hide *ngIf="row.counterPathPassword" [value]="row.counterPathPassword || '&nbsp;'"></app-show-hide>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="lastLoginTime">
        <mat-header-cell *matHeaderCellDef mat-sort-header="lastLoginTime">SoftPhone Last Login</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">SoftPhone Last Login:</span>
          <div>{{ row.lastLoginTime | unixTime}}</div>
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
